import React from 'react';
import Modal from '../../Common/Modal';
import {Noblocked } from '../images';
import { SettingsHeader } from '../Settings';
import './BlockedContacts.scss';
import { getContactNameFromRoster, formatUserIdToJid } from '../../../../Helpers/Chat/User';
import UserStatus from '../../Common/UserStatus';
import { toast } from 'react-toastify';
import { CHAT_TYPE_SINGLE, UNBLOCK_CONTACT_TYPE } from '../../../../Helpers/Chat/Constant';
import { store } from '../../../../Redux/store';
import { updateBlockedContactAction } from '../../ConversationSection/PopUp/BlockAction';
import SDK from '../../../../SDK';
import ProfileImage from '../../../Common/ProfileImage';
import BlockPopUp from '../../ConversationSection/PopUp/BlockPopUp';
import { getFromLocalStorageAndDecrypt } from '../../../../Helpers/Chat/webChatEncryptDecrypt';
import { useSelector } from 'react-redux';

const BlockedContacts = (props = {}) => {
   const State = useSelector(state => state)
   const { blockedContact } = State;

   const [blockedContacts, setBlockedContacts] =
    React.useState({
      contactDetails: [],
      showModal:false,
      nameToDisplay:'',
      userId:null
    });

   const {
      contactDetails,
      showModal,
      nameToDisplay,
      userId
   } = blockedContacts;


   React.useEffect(()=>{
      prepareToDisplay();
   },[])

   React.useEffect(()=>{
      prepareToDisplay();
   },[blockedContact])

   const prepareToDisplay = () => {
      const { rosterData: { data: rosterDataArray = [] } = {},
      blockedContact: { data: blockedContactArr = [] } = {} } = State;
      const contactDetails = rosterDataArray.filter((profile) => {
         let rosterJid = (profile.username) ? profile.username : profile.userJid;
         rosterJid = !rosterJid ? profile.userId : rosterJid;
         if(!rosterJid || rosterJid.indexOf('@mix') > -1) return false;
         rosterJid = formatUserIdToJid(rosterJid);
         return blockedContactArr.indexOf(rosterJid) > -1;
      });

      setBlockedContacts({...blockedContacts,
         contactDetails: contactDetails
      })
   }

   const popUpToggleAction = (userId, nameToDisplay) => {
      setBlockedContacts({ ...blockedContacts,
         showModal:!showModal,
         userId:userId || null,
         nameToDisplay:nameToDisplay || null
      })
   }

   const dispatchAction = async()=>{
      setBlockedContacts({...blockedContacts,
         showModal:!showModal
      })
         const res = await SDK.unblockUser(userId);
         if(res && res.statusCode === 200){
            store.dispatch(updateBlockedContactAction(userId, UNBLOCK_CONTACT_TYPE));
            toast.success(`${nameToDisplay || 'User'} has been Unblocked`);
            /**
            // handleTempArchivedChats(blockId, CHAT_TYPE_SINGLE);
            */
         }
      
   }

   const renderProfile = () => {
      if (contactDetails.length === 0) return null
      const token = getFromLocalStorageAndDecrypt('token');
      return contactDetails.map((contact) => {
         const { chatType, image, thumbImage, emailId, statusMsg, status, userId, userJid } = contact
         const nameToDisplay = getContactNameFromRoster(contact)
         return (
            <li key={userId} className="chat-list-li">
               <ProfileImage
                  chatType={chatType || CHAT_TYPE_SINGLE}
                  userToken={token}
                  imageToken={thumbImage !== "" ? thumbImage : image}
                  emailId={emailId}
                  userId={userId}
                  name={nameToDisplay}
               />
               <div className="recentchats">
                  <div className="recent-username-block">
                     <div className="recent-username">
                        <div className="username">
                           <h3 title={nameToDisplay}>{nameToDisplay}</h3>
                        </div>
                     </div>
                  </div>
                  <div className="recent-message-block">
                     <UserStatus status={statusMsg || status} userId={userId} />
                  </div>
               </div>
               <span className="Unblock" onClick={() => { popUpToggleAction(userJid,nameToDisplay) }}>Unblock</span>
            </li>
         )
      })
   }

   
      const { handleBackToSetting } = props
      return (
         <div className="setting-container">
            {showModal && <Modal containerId='container'>
               <BlockPopUp
                  popUpToggleAction={popUpToggleAction}
                  dispatchAction={dispatchAction}
                  headerLabel={<>{'Unblock'} {nameToDisplay} ?</>}
                  closeLabel={'Cancel'}
                  actionLabel={'Unblock'}
                  infoLabel={'On unblocking, this contact will be able to call you or send messages to you.'}
               />
            </Modal>}
            <div>
               <div className="settinglist ">
                  <SettingsHeader
                     handleBackFromSetting={handleBackToSetting}
                     label={'Blocked Contacts'}
                  />
                  {contactDetails.length > 0 &&
                     <ul className="chat-list-ul BlockedList">
                        {renderProfile()}
                     </ul>
                  }
                  {contactDetails.length === 0 &&
                     <div className="setting-list-ul BlockedContact">
                        <div className="EmptyBlockedContact">
                           <i><Noblocked /></i>
                           <p>No Blocked Contacts Found</p>
                        </div>
                     </div>
                  }
               </div>
            </div>
         </div>
      );
   }

export default BlockedContacts;
